module.exports = __webpack_public_path__ + "static/media/banner.79ae1de4.jpg";